export default {"src":"/_next/static/media/seimens.bbe67533.svg","height":50,"width":302,"blurWidth":0,"blurHeight":0};